import { MoedaVendaEnum } from '../types/enums/moeda-venda.enum';

export function formatCurrency(
  raw: number | undefined | null,
  moeda: MoedaVendaEnum,
): string {
  const valor =
    typeof raw === 'number' && !Number.isNaN(raw) ? raw : 0;

  switch (moeda) {
    case MoedaVendaEnum.BRL:
      return `R$${valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    case MoedaVendaEnum.USD:
      return `U$${valor.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    case MoedaVendaEnum.EUR:
      return `€${valor.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    case MoedaVendaEnum.CLP:
      return `$${valor.toLocaleString('es-CL')}`;
    case MoedaVendaEnum.PEN:
      return `S/.${valor.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    case MoedaVendaEnum.COP:
      return `$${valor.toLocaleString('es-CO')}`;
    case MoedaVendaEnum.MXN:
      return `Mex$${valor.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    case MoedaVendaEnum.CAD:
      return `CA$${valor.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    case MoedaVendaEnum.JPY:
      return `¥${valor.toLocaleString('ja-JP')}`;
    case MoedaVendaEnum.GBP:
      return `£${valor.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    case MoedaVendaEnum.DKK:
      return `kr${valor.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    case MoedaVendaEnum.NOK:
      return `kr${valor.toLocaleString('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    case MoedaVendaEnum.SEK:
      return `kr${valor.toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    case MoedaVendaEnum.PYG:
      return `₲${valor.toLocaleString('es-PY')}`;
    case MoedaVendaEnum.CHF:
      return `CHF ${valor.toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    default:
      return `${valor}`;
  }
}
